import { IRawRichTextContentState } from '../../../view/models/Api';
import { IContact } from './index';

export enum ParserType {
	Custom = 'Custom',
	AI = 'AI',
}

export interface IAILeadParserOptions {
	enabled: boolean;
}

export interface IParsedLead {
	tag?: string;
	contact?: Partial<IContact>;
	note?: IRawRichTextContentState;
}
